/*
 * Submission adapter for the register-interest form.
 *
 * WEB TEAM: set REACT_APP_REGISTRATION_ENDPOINT (see .env) to your backend
 * or CRM URL. The form POSTs the payload as JSON wrapped in { formTag, data }
 * and treats any non-2xx response as a failure.
 *
 * Until an endpoint is configured, nothing is saved: the adapter rejects so the
 * form shows its error state rather than a false thank-you screen.
 */
const ENDPOINT = process.env.REACT_APP_REGISTRATION_ENDPOINT || '';
const FORM_TAG = process.env.REACT_APP_REGISTRATION_FORM_TAG || 'ELEVEN_POWER_EOI';

export class SubmissionNotConfiguredError extends Error {
  constructor() {
    super('No registration endpoint is configured (REACT_APP_REGISTRATION_ENDPOINT).');
    this.name = 'SubmissionNotConfiguredError';
  }
}

export async function submitRegistration(payload) {
  if (!ENDPOINT) {
    throw new SubmissionNotConfiguredError();
  }

  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ formTag: FORM_TAG, data: payload }),
  });

  if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
}
